import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation sendDeclinedTimeRegEmailReminderMutation($input: SendDeclinedTimeRegEmailReminderInput!) {
		sendDeclinedTimeRegEmailReminder(input: $input) {
			clientMutationId
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Declined timesheet reminder sent');
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
